<template>
	<BaseCmsPage @load="onPageLoad">
		<Body class="page-checkout" />
		<ClientOnly>
			<BaseWebshopCart v-slot="{cart, parcels}">
				<div class="wrapper">
					<form @submit.prevent="onSubmit" v-if="cart">
						<WebshopCheckoutLayout>
							<template #col1>
								<WebshopSteps :step="1" class="completed" />
								<WebshopSelectedCustomer />
								
								<WebshopSteps class="active" :step="2" />
								<div class="wc-form wc-form-shipping floating-labels">
									<div class="wc-form-col1">
										<!--
										<ClientOnly>
											<WebshopHelloBar />
										</ClientOnly>
										-->

										<div v-if="shippingLeanpayError" class="global-warning unavailable-item special">
											<div class="title"><BaseCmsLabel code="leanpay_shipping_note" tag="strong" /></div>
											<div class="btns-block">
												<div class="btn-vlose" @click="hiddeErrorMessage()">
													<span><BaseCmsLabel code="hidde_error" /></span>
												</div>
											</div>
										</div>

										<WebshopShippingMerge :data="cart" />
										<div class="wc-packages">
											<template v-if="parcels?.length">
												<template v-for="parcel in parcels" :key="parcel.number">
													<WebshopPackage :parcel="parcel" />
												</template>
											</template>
										</div>
									</div>
								</div>
								<WebshopSteps :step="3" class="disabled" />
							</template>
							<template #col2>
								<WebshopCheckoutSidebar :meta="meta" step="shipping" />
							</template>
						</WebshopCheckoutLayout>
					</form>
				</div>
			</BaseWebshopCart>
			<template #fallback>
				<UiLoader class="spacing" />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	import {useForm} from 'vee-validate';

	const webshop = useWebshop();
	const auth = useAuth();
	const apiRoutes = useApiRoutes();
	const cartData = computed(() => webshop.getCartData());
	const { shippingLeanpayError, checkoutLoading, formValid, selectedShipping } = useCheckout();

	// watch if form is valid
	const { meta } = useForm();
	watch(
		() => meta,
		() => formValid.value = (meta.value.valid) ? 1 : 0,
		{deep: true}
	)

	// redirect to cart page if there are errors in cart
	if (cartData.value?.cart?.errors?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	// redirect to cart page if there are warnings in cart
	if (cartData.value?.cart?.warnings?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	//hidde error message
	function hiddeErrorMessage() {
		shippingLeanpayError.value = 0;
	};

	//on submit
	async function onSubmit() {
		checkoutLoading.value = true;
		await navigateTo(apiRoutes.getAppUrl('webshop_review_order'));
		checkoutLoading.value = false;
	}

	//gtm
	const {gtmTrack} = useGtmBB();
	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>


<style lang="less" scoped>
	:deep(.wc-step3){
		padding-bottom: 0;
		@media (max-width: @m){padding-bottom: 23px;}
	}
	.wc-packages {
		flex-grow: 1; display: flex; flex-direction: column; gap: 18px;
		position: relative;
		&.special{
			margin-top: 25px; padding-top: 30px; border-top: 1px solid var(--borderColor);
			@media (max-width: @m){padding-top: 25px;}
		}
	}
</style>